(function () {
  'use strict';

  var STORAGE_KEY = 'qreative_attribution';
  var QUERY_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var ATTRIBUTION_FIELDS = [
    {
      key: 'source_page',
      contactName: 'Source page',
      read: function (data) { return data.source_page || ''; }
    },
    {
      key: 'source_cta',
      contactName: 'Source CTA',
      read: function (data) { return data.last_cta_label || data.last_cta || ''; }
    },
    {
      key: 'workshop',
      contactName: 'Workshop',
      read: function (data) { return data.workshop || ''; }
    },
    {
      key: 'city',
      contactName: 'City',
      read: function (data) { return data.city || ''; }
    },
    {
      key: 'utm',
      contactName: 'UTM',
      read: function (data) { return buildUtmValue(data); }
    }
  ];

  function readStoredAttribution() {
    try {
      var stored = window.sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredAttribution(data) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      return data;
    }

    return data;
  }

  function buildUtmValue(data) {
    var parts = [];

    QUERY_KEYS.forEach(function (key) {
      if (data[key]) parts.push(key + '=' + encodeURIComponent(data[key]));
    });

    return parts.join('&');
  }

  function readAttribution() {
    var data = readStoredAttribution();
    var params = typeof URLSearchParams === 'function' ? new URLSearchParams(window.location.search) : null;

    data.source_page = window.location.pathname;
    if (!data.landing_page) data.landing_page = window.location.href;
    if (!data.referrer && document.referrer) data.referrer = document.referrer;
    if (!data.first_touch_at) data.first_touch_at = new Date().toISOString();

    if (params) {
      QUERY_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) data[key] = value;
      });
    }

    return writeStoredAttribution(data);
  }

  function getCtaElement(target) {
    var element = target;
    if (!element || element.nodeType !== 1) element = element && element.parentElement;
    if (!element) return null;

    var cta = element.closest ? element.closest('[data-qr-cta]') : null;
    if (!cta) return null;

    if (cta.nodeName !== 'A' && cta.nodeName !== 'BUTTON') {
      var actionable = cta.closest ? cta.closest('a, button') : null;
      if (actionable) return actionable;
    }

    return cta;
  }

  function publish(eventName, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (error) {
      /* Analytics must never block navigation or form submission. */
    }

    try {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    } catch (error) {
      return payload;
    }

    return payload;
  }

  function rememberCta(element) {
    var data = readAttribution();
    data.last_cta = element.getAttribute('data-qr-cta') || '';
    data.last_cta_label = (element.getAttribute('data-qr-cta-label') || element.textContent || '').trim();
    data.last_cta_href = element.getAttribute('href') || element.getAttribute('formaction') || '';
    data.last_cta_at = new Date().toISOString();
    return writeStoredAttribution(data);
  }

  function isLeadForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if (form.id === 'ContactFooter' || form.classList.contains('newsletter-form')) return false;

    var action = form.getAttribute('action') || '';
    return Boolean(
      action.indexOf('/contact') !== -1 ||
      form.querySelector('[name="contact[email]"], [name="contact[phone]"], [name="contact[company]"]')
    );
  }

  function findAttributionField(form, entry) {
    return form.querySelector(
      '[data-qr-attribution-field="' + entry.key + '"], ' +
      '[name="contact[' + entry.contactName + ']"]'
    );
  }

  function upsertHiddenField(form, entry, value) {
    var field = findAttributionField(form, entry);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[' + entry.contactName + ']';
      field.setAttribute('data-qr-attribution-field', entry.key);
      form.appendChild(field);
    }
    field.value = value;
  }

  function readFormContext(form, data) {
    var workshopField = form.querySelector('[name="contact[Workshop]"]');
    var cityField = form.querySelector('[name="contact[City]"]');
    var occasionField = form.querySelector('[name="contact[occasion]"], [name="contact[workshop]"]');
    var visibleCityField = form.querySelector('[name="contact[city]"], [name="contact[cities]"]');

    if ((!data.workshop || data.workshop === '') && occasionField && occasionField.value) {
      data.workshop = occasionField.value.trim();
    }
    if ((!data.city || data.city === '') && visibleCityField && visibleCityField.value) {
      data.city = visibleCityField.value.trim();
    }

    if ((!data.workshop || data.workshop === '') && workshopField && workshopField.value) {
      data.workshop = workshopField.value.trim();
    }
    if ((!data.city || data.city === '') && cityField && cityField.value) {
      data.city = cityField.value.trim();
    }

    return data;
  }

  function addAttributionToForm(form) {
    if (!isLeadForm(form)) return;

    var data = readAttribution();
    var formContext = readFormContext(form, {});
    data.workshop = formContext.workshop || '';
    data.city = formContext.city || '';
    ATTRIBUTION_FIELDS.forEach(function (entry) {
      var value = entry.read(data);
      var existing = findAttributionField(form, entry);
      if (!value && existing) value = existing.value || '';
      upsertHiddenField(form, entry, value);
    });
    writeStoredAttribution(data);
  }

  function initStickyCtaFoundation() {
    document.querySelectorAll('[data-qr-sticky-cta]').forEach(function (element) {
      element.classList.add('qr-sticky-cta');
    });
  }

  function pauseDawnAutoplayForReducedMotion() {
    if (!window.matchMedia) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pauseSlideshow = function () {
      if (!reducedMotion.matches) return;

      document.querySelectorAll('slideshow-component').forEach(function (slideshow) {
        if (typeof slideshow.pause === 'function') slideshow.pause();
      });
    };

    pauseSlideshow();
    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', pauseSlideshow);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(pauseSlideshow);
    }
  }

  function publishCtaClick(element) {
    if (!element) return null;

    var data = rememberCta(element);
    return publish('qreative_cta_clicked', {
      cta: data.last_cta,
      label: data.last_cta_label,
      href: data.last_cta_href,
      page: window.location.pathname,
      attribution: data
    });
  }

  function init() {
    readAttribution();
    initStickyCtaFoundation();
    pauseDawnAutoplayForReducedMotion();

    document.querySelectorAll('form').forEach(addAttributionToForm);

    document.addEventListener('click', function (event) {
      var cta = getCtaElement(event.target);
      if (!cta) return;
      publishCtaClick(cta);
    }, true);

    document.addEventListener('submit', function (event) {
      addAttributionToForm(event.target);
    }, true);

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.nodeName === 'FORM') addAttributionToForm(node);
            if (node.querySelectorAll) node.querySelectorAll('form').forEach(addAttributionToForm);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.QreativeAttribution = {
    get: readAttribution,
    addToForm: addAttributionToForm,
    rememberCta: function (element) {
      return element ? rememberCta(element) : readAttribution();
    }
  };

  window.QreativeAnalytics = {
    publish: publish,
    publishCtaClick: publishCtaClick
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
